import React, { useState } from 'react';
import Styled from 'styled-components';
import { Modal } from '@organisms/modals/base';
import { ProgramSurvey } from '@gql/generated';

const Loading = Styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutrals.gray};
  text-align: center;
  padding: 20px;
`;

const StyledModal = Styled(Modal)`
  overflow-y: scroll;

  .MuiBackdrop-root {
    display: none;
  }


  .MuiDialog-paperScrollPaper {
    max-height: none;
  }

  .MuiDialog-container.MuiDialog-scrollPaper:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    /* bottom: 0; */
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

  .ModalWrapper {
    width: 600px;
  }

  & ${Loading} {
    display: block;
  }

  & ${Loading}:first-of-type:last-of-type {
    display: none;
  }

  @media(min-width: ${({ theme }) => theme.sizes.DesktopUpBreakpoint}px){
    .ModalWrapper {
      width: 1400px;
      margin: 0;
    }
  }
`;

declare type Props = {
  data: {
    survey: ProgramSurvey;
    user_id: string;
    program_slug: string;
  };
  open?: boolean;
  onComplete(any): void;
};

const SurveyModalHook = ({
  data,
  open = false,
}: Props): [
  JSX.Element,
  { isOpen: boolean; openModal(): void; closeModal(): void }
] => {
  const [isOpen, setIsOpen] = useState(open);

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const link = data?.survey?.link;

  // reverse so its easier to pick [1]
  const survey_embed_id = String(link)
    // split into array of letters
    .split('')
    // reverse array
    .reverse()
    // join into reversed link
    .join('')
    // split by '.' and take index = 1, because id is before '.js'
    ?.split('.')[1]
    // split to convert reverse id to array
    ?.split('')
    // reverse array into proper order
    ?.reverse()
    // join the array into proper survey id
    ?.join('');

  const Content = isOpen ? (
    <StyledModal open={isOpen} handleClose={onClose}>
      <script type="application/javascript" src={link}></script>
      <div
        id={`surveyhero-embed-${survey_embed_id}`}
        data-user_id={data.user_id}
        data-prog_surv_id={data.survey.id}
      ></div>
    </StyledModal>
  ) : (
    <React.Fragment />
  );

  return [Content, { isOpen, openModal: onOpen, closeModal: onClose }];
};

export default SurveyModalHook;
